import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { MenuPath } from '../../touchpose/ui';
import {
  H2,
  Body,
  DocHero,
  KeySettings,
  QuadCages,
  DocFooter, Steps
} from './shared';

const M = (s: string) => <MenuPath>{s}</MenuPath>;

const COMPONENT = 'Squarebit Subdiv Static Mesh Component';

const StaticMeshesDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary max-w-[760px]">
      <DocHero
        title={t('subdivsDocs.layout.staticMeshes')}
        intro={
          <Trans
            i18nKey="subdivsDocs.staticMeshes.intro"
            components={{ comp: <>{COMPONENT}</>, sm: <>Static Mesh</> }}
          />
        }
      />

      <H2 id="adding">{t('subdivsDocs.layout.adding')}</H2>
      <Steps>
        <><Trans
            i18nKey="subdivsDocs.staticMeshes.step1"
            components={{ smc: <>Static Mesh Component</> }}
          /></>
        <><Trans
            i18nKey="subdivsDocs.staticMeshes.step2"
            components={{
              add: M('Add'),
              q: <em>&ldquo;Squarebit Subdiv Static Mesh&rdquo;</em>,
              comp: <strong>{COMPONENT}</strong>
            }}
          /></>
        <><Trans
            i18nKey="subdivsDocs.staticMeshes.step3"
            components={{ details: <>Details</> }}
          /></>
      </Steps>

      <H2 id="quads">{t('subdivsDocs.layout.quads')}</H2>
      <Body>
        <Trans
          i18nKey="subdivsDocs.staticMeshes.quadsBody"
          components={{ cc: <>Catmull-Clark</> }}
        />
      </Body>

      <KeySettings />
      <QuadCages naniteWarning />
      <DocFooter current="/squarebit-subdivs/docs/static-meshes" />
    </article>
  );
};

export default StaticMeshesDoc;
